var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSquareThumbnail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 244,
    height: 244,
    viewBox: "0 0 244 244",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_173",
    "data-name": "Rectangle 173",
    width: 244,
    height: 244,
    transform: "translate(6070 12748)",
    fill: "#d1d4d9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Square_Thumbnail",
    "data-name": "Square Thumbnail",
    transform: "translate(-6070 -12748)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_172",
    "data-name": "Rectangle 172",
    width: 244,
    height: 244,
    transform: "translate(6070 12748)",
    fill: "#d1d4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_8",
    "data-name": "Polygon 8",
    d: "M76.5,0,153,131H0Z",
    transform: "translate(6046 12861)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_9",
    "data-name": "Polygon 9",
    d: "M107.5,0,215,184H0Z",
    transform: "translate(6123 12808)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_32",
    "data-name": "Ellipse 32",
    cx: 28,
    cy: 28,
    r: 28,
    transform: "translate(6091 12778)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareThumbnail);
export default __webpack_public_path__ + "static/media/SquareThumbnail.d538c119f3c470df176cd1f0491218f2.svg";
export { ForwardRef as ReactComponent };